export function showFlexWarning(country) {
  const countryList = ["PT"];

  return countryList.some((countryCode) => countryCode === country);
}

export function shouldDisableFlex(country) {
  const countryList = ["PT"];

  return countryList.some((countryCode) => countryCode === country);
}

export function showCustomTooltip(country) {
  const countryList = ["PT"];

  return countryList.some((countryCode) => countryCode === country);
}

export function shouldShowLegalAdvice(country) {
  const countryList = ["PT"];

  return countryList.some((countryCode) => countryCode === country);
}

export const mealBenefitLimits = ({ country }) => {
  const limits = {
    // TODO: figure out a way to not enforce this limit when undefined
    PT: 1000,
    ES: 11,
  };
  return country in limits ? limits[country] : 11;
};

export const shouldFilterTaxRegimes = (country) => {
  const countryList = ["PT"];

  return countryList.some((countryCode) => countryCode === country);
};

export const shouldHideTransport = (country) => {
  const countryList = ["PT"];

  return countryList.some((countryCode) => countryCode === country);
};
